import React, { useState } from 'react';
import styles from './PassResetByEmail.module.scss';
import { ReactComponent as IconBack } from 'images/icons/go-back.svg';
import { PassInput } from 'components/shared/Input';
import { StringConstant } from 'utils/Constants';
import { validatePassword } from 'sdk/utils/validation';
import Button from 'components/shared/Button';
import supabase from 'sdk/api';
import { useNavigate } from 'react-router-dom';
const NewPass = () => {
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  const [isPassVisible, setIsPassVisisble] = useState(false);
  const [passError, setPassError] = useState(false);

  const navigate = useNavigate();

  const handlePasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    setPass((e.target as HTMLInputElement).value);
    setPassError(false);
  };

  const handlePassword2Change = (e: React.FormEvent<HTMLInputElement>) => {
    setPass2((e.target as HTMLInputElement).value);
    setPassError(false);
  };
  const isPassValid = validatePassword(pass) && pass === pass2;

  return (
    <div
      className={styles.form}
      style={{
        height: '100vh',
      }}
    >
      <div className={styles.passResetByEmail}>
        <div className={styles.passResetByEmail__back}>
          <IconBack />
        </div>
        <div className={styles.passResetByEmail__title}>Password Recovery</div>
        <div className={styles.passResetByEmail__none}></div>
      </div>
      <PassInput
        className={styles.margin20}
        value={pass}
        onChange={handlePasswordChange}
        isVisible={isPassVisible}
        switchVisibility={() => setIsPassVisisble(!isPassVisible)}
        error={passError}
        onBlur={() => setPassError(!isPassValid)}
        placeholder="New Password"
        wide
        white
      />

      <PassInput
        className={styles.margin20}
        value={pass2}
        onChange={handlePassword2Change}
        isVisible={isPassVisible}
        switchVisibility={() => setIsPassVisisble(!isPassVisible)}
        error={passError}
        errorMessage={
          pass === pass2 ? StringConstant.NEW_PASSWORD_ERROR : StringConstant.NEW_PASSWORD_MISMATCH
        }
        onBlur={() => setPassError(!isPassValid)}
        placeholder="Repeat Password"
        wide
        white
      />
      <Button
        wide
        darkGreen
        type="submit"
        style={{ marginTop: 'auto' }}
        onClick={async () => {
          const { data, error } = await supabase.auth.updateUser({ password: pass });

          if (data) {
            navigate('/');
          }
          if (error) {
            console.log('There was an error updating your password.');
          }
        }}
      >
        Change Password
      </Button>
    </div>
  );
};

export default NewPass;
